export default "__VITE_ASSET__Bjt4SReH__"